import type { DocumentTemplate } from 'modules/documents/hooks/useGetDocumentTemplates'
import type Variable from 'modules/documents/store/models/Variable'

export enum VariablesAccess {
  Full = 'full',
  NoAccess = 'no_access',
  Partial = 'partial',
}

const getVariablesAccess = (documentTemplate: DocumentTemplate, templateVariables: Variable[]) => {
  let noAccess = 0
  let partialAccess = 0

  const filteredVariables = templateVariables.filter((variable) =>
    documentTemplate.values!.includes(variable.attributes.variable)
  )

  for (const variable of filteredVariables) {
    if (variable.attributes.access == VariablesAccess.NoAccess) {
      noAccess += 1
      break
    }
    if (variable.attributes.access == VariablesAccess.Partial) {
      partialAccess += 1
    }
  }

  if (noAccess > 0) {
    return VariablesAccess.NoAccess
  } else if (partialAccess > 0) {
    return VariablesAccess.Partial
  }

  return VariablesAccess.Full
}

export default getVariablesAccess
